export enum EventApplication {

  AppInit = 'AppInit'

}

export enum EventUI {

  NavigateToLogin = 'auth.login',
  NavigateToLogout = 'auth.logout',
  NavigateToPasswordReset = 'auth.password.reset',
  NavigateToHome = 'navigate.home',
  NavigateToDepotList = 'depot.list',
  NavigateToDeviceList = 'device.list',
  NavigateToResourceList = 'NavigateToResourceList',
  NavigateToPostmanList = 'postman.list',
  NavigateToShipmentList = 'shipment.list',
  NavigateToShipmentReturns = 'NavigateToShipmentReturns',
  NavigateToShipmentLost = 'NavigateToShipmentLost',
  NavigateToDeviceUserList = 'NavigateToDeviceUserList',
  NavigateToWebUserList = 'NavigateToWebUserList',
  NavigateToVersionList = 'version.list',
  NavigateToSettingList = 'setting.list',
  NavigateToDeviceUserDialog = 'NavigateToDeviceUserDialog',
  NavigateToWebUserDialog = 'NavigateToWebUserDialog',
  NavigateToMessageDialog = 'message.dialog',
  NavigateToDeviceDialog = 'NavigateToDeviceDialog',
  NavigateToMandatorAssignDialog = 'NavigateToMandatorAssignDialog',
  NavigateToShipmentsBookToDepot = 'shipments.book.to.depot',
  NavigateToLocationMap = 'NavigateToLocationMap',
  NavigateToTour = 'NavigateToTour',

}

export enum EventDevice {

  DeviceStateChanged = 'DeviceStateChanged'

}
